import React, { useState, useEffect, useCallback, useMemo } from "react";
//Hooks
import useGetCargosExterno from "../Hooks/useGetCargosExterno";

//Componentes de Material UI
import {
    Autocomplete,
    TextField,
    List,
    ListItem,
    ListItemText,
    Box,
    CircularProgress,
    Alert,
    AlertTitle,
    Tooltip,
    IconButton,
    createFilterOptions,
} from "@mui/material";

//Iconos
import { Refresh as RefreshIcon } from "@mui/icons-material";
import { debounce } from "lodash";

// Filtro personalizado
const filterOptions = createFilterOptions({
    matchFrom: "any",
    ignoreAccents: true,
    ignoreCase: true,
    stringify: (option) => option,
});

const DropdownCargosExternos = ({
    id,
    value,
    name,
    onChange,
    disabled,
    error,
    helperText,
    label,
    required,
}) => {
    const [options, setOptions] = useState([]);
    const [inputValue, setInputValue] = useState(value || ""); // Guarda el texto ingresado

    const { data, refreshGetData } = useGetCargosExterno();

    useEffect(() => {
        if (Array.isArray(data) && data.length > 0) {
            setOptions(data.map((option) => option.strNombreCargo));
        }
    }, [data]);

    useEffect(() => {
        setInputValue(value || "");
    }, [value]);


    if (!data) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                <CircularProgress size={30} />
            </Box>
        );
    }

    if (data.error) {
        return (
            <Alert
                severity="error"
                action={
                    <IconButton onClick={refreshGetData} size="large">
                        <Tooltip title="Refrescar">
                            <RefreshIcon />
                        </Tooltip>
                    </IconButton>
                }
            >
                <AlertTitle>
                    <b>{data.msg}</b>
                </AlertTitle>
                Ha ocurrido un error al obtener los datos del listado de universidades.
            </Alert>
        );
    }

    return (
        <Autocomplete
            id={id}
            value={value}
            onChange={onChange}
            options={options}
            openText="Abrir"
            closeText="Cerrar"
            noOptionsText="Valor no encontrado."
            disabled={disabled}
            fullWidth
            autoComplete="off"
            filterOptions={filterOptions}
            renderInput={(props) => (
                <TextField
                    {...props}
                    label={label}
                    name={name}
                    error={error}
                    required={required}
                    helperText={helperText}
                />
            )}
            getOptionLabel={(option) => option || ""}
            renderOption={(props, option) => (
                <List {...props} disablePadding>
                    <ListItem>
                        <ListItemText primary={option} />
                    </ListItem>
                </List>
            )}
        />
    );
};

export default DropdownCargosExternos;